import { render, staticRenderFns } from "./v-speak-text.vue?vue&type=template&id=11a017c0&scoped=true&"
import script from "./v-speak-text.vue?vue&type=script&lang=js&"
export * from "./v-speak-text.vue?vue&type=script&lang=js&"
import style0 from "./v-speak-text.vue?vue&type=style&index=0&id=11a017c0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11a017c0",
  null
  
)

export default component.exports